import React from 'react'
import { Button, Card, CardContent, CardHeader, Divider, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Checkbox, TextField } from '@carsys/form'

export interface Props {
  onTreeExport: () => void
}

const Data: React.FC<Props> = ({ onTreeExport }) => {
  const { t } = useTranslation()

  return (
    <Card variant='outlined'>
      <CardHeader
        title={<Typography variant='h6'>{t('productgroup.tree_data_title')}</Typography>}
        action={
          <Button onClick={onTreeExport} data-testid='btn-export'>
            {t('ProductGroup.ExportTree')}
          </Button>
        }
      />
      <Divider />
      <CardContent>
        <TextField fullWidth variant='outlined' label={t('productgroup.name')} name='Name' data-testid='data-name-input' required />
        <Checkbox name='IsActive' label={t('productgroup.is_active')} data-testid='is-active-checkbox' />
      </CardContent>
    </Card>
  )
}

export default Data
